import { genUniqueId } from "../utils";

// CREATE
export const CREATE_EVENT = "CREATE_EVENT";

export function createEvent(humanId, date, label) {
  return {
    type: CREATE_EVENT,
    id: genUniqueId(),
    humanId,
    date,
    label,
  };
}

// UPDATE
export const UPDATE_EVENT = "UPDATE_EVENT";

export function updateEvent(id, obj) {
  return {
    type: UPDATE_EVENT,
    id,
    obj,
  };
}

// DELETE
export const DELETE_EVENT = "DELETE_EVENT";

export function deleteEvent(id) {
  return {
    type: DELETE_EVENT,
    id,
  };
}
